/* eslint-disable @typescript-eslint/indent */
import { getBFFApiClient } from '@acp/feature/auth';
import { APIResponse, PortfolioProperty } from '@acp/shared';
import HttpStatusCodes from 'http-status-codes';
import { UpdatesRequiredFilters } from './components/sidebar-options';

async function getProperties(params: UpdatesRequiredFilters, pageNumber: number, pageSize: number) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const queryParams: any = {
        query: params.query ?? '',
        service: params.services,
        facet: params.facets,
        serviceExclusivity: params.serviceExclusivity,
        page: pageNumber,
        'property-manager': [params.propertyManager],
        'page-size': pageSize,
    };

    const response = await getBFFApiClient().get<
        APIResponse<{
            total: number;
            items: PortfolioProperty[];
            unfilteredTotal: number;
        }>
    >('/v1/update/summary', {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        params: queryParams,
    });

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error(`Failed to get properties: ${response.data.error}`);
    }

    return response.data.data;
}

async function getAllOverdueProperties() {
    const response = await getBFFApiClient().get<
        APIResponse<{ items: PortfolioProperty[]; total: number }>
    >('/v1/update/get-all-overdue-properties');

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error(`Failed to update all overdue properties: ${response.data.error}`);
    }

    return response.data.data;
}

async function confirmSinglePropertyDetails(propertyId: number | string) {
    const response = await getBFFApiClient().post<APIResponse< { 'success': boolean; 'message': string; 'propertyId': number | null } >>(
        `/v1/property/${propertyId}/confirm-single-property-details`
    );

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error('Failed to confirm the property details for this property.');
    }

    return response.data.data;
}

async function updateKeyNumber(propertyId: string | number, keyNumber: string) {
    const response = await getBFFApiClient().post<APIResponse<void>>(
        `/v1/property/${propertyId}/key-number`,
        {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            keyNumber,
        }
    );

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error(`Failed to update key number: ${response.data.error}`);
    }

    return response.data.data;
}

async function exportUpdateExcel() {
    const res = await getBFFApiClient().get<Blob>(
        '/v1/update/summary/export',
        {
            responseType: 'blob',
        }
    );

    if (res.status !== HttpStatusCodes.OK) {
        throw new Error('Failed to export update report');
    }

    return URL.createObjectURL(res.data);
}

export {
 getProperties,
 updateKeyNumber,
 exportUpdateExcel,
 confirmSinglePropertyDetails,
 getAllOverdueProperties,
};
